/**
 * Canonical student/lead/batch age groups.
 * Keep in sync with src/constants/ageGroups.js and
 * mobile-code/apps/teacher/src/constants/ageGroups.ts
 */
export const AGE_GROUPS = ['4-6', '7-9', '10-12', '13-15', '16+'];

export const AGE_GROUP_LABELS = {
  '4-6': '4-6 years',
  '7-9': '7-9 years',
  '10-12': '10-12 years',
  '13-15': '13-15 years',
  '16+': '16+ years',
};

export function ageToAgeGroup(age) {
  if (age == null || age === '') return null;
  const n = Number(age);
  if (!Number.isFinite(n) || n < 0) return null;
  if (n <= 6) return '4-6';
  if (n <= 9) return '7-9';
  if (n <= 12) return '10-12';
  if (n <= 15) return '13-15';
  return '16+';
}

/** Current five options, plus the stored value if it is a leftover legacy label. */
export function getAgeGroupSelectOptions(currentValue) {
  const options = AGE_GROUPS.map((value) => ({
    value,
    label: AGE_GROUP_LABELS[value] || value,
  }));
  const current = currentValue ? String(currentValue) : '';
  if (current && !AGE_GROUPS.includes(current)) {
    options.push({ value: current, label: `${current} (legacy)` });
  }
  return options;
}
